import { Validators } from '@angular/forms';

export class AssetsDetailsModel {
  assetsList = {
    value: [],
    validation: Validators.compose([])
  };
  totalAssetsValue = {
    value: 0,
    validation: Validators.compose([])
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class IndividualAssetModel {
  type = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  description = {
    value: null,
    validation: Validators.compose([])
  };
  amount = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };
  refinance = {
    value: false,
    validation: Validators.compose([])
  };
  parties = [];
}
